function About() {
  return (
    <main>
        <h4>Zawarte przeze mnie obrazki wziąłem z  
            <a href="https://www.svgrepo.com/collection/office-supplies-tritone-bordered-vectors"> {'<'}LINK{'>'}</a></h4>
        <h4>Za późno zorientowałem się że pomysł nie za bardzo pasuje do responsywnej strony (pisanie na klawiaturze na telefonie)
            więc responsywność postanowiłem w podstronie /game zrobić po prostu ukrywając i pokazując komunikat oraz gre.
            Rensponsywna jest również czcionka w niektórych miejscach oraz navbar (zarówno rozmiar jak i ułożenie elementów).
        </h4>
        <h4>
            Tło do strony jest z <a href="https://www.magicpattern.design/tools/css-backgrounds">{'<'}LINK{'>'}</a>
        </h4>
    </main>
  );
}

export default About;
